<template>

  <v-container v-if="bookingContext">


    <v-progress-linear :active="loading" :indeterminate="loading" absolute
                       color="deep-purple accent-4"></v-progress-linear>


    <BookingHeader :bookingContext="bookingContext"/>

    <span v-if="!loggedUser">
        <v-row>
           <v-col cols="4">
        <LoginForm redirectUrl=""></LoginForm>
         </v-col>
         <v-col cols="6">
        <CreateUser redirectUrl=""></CreateUser>
      </v-col>
         </v-row>
    </span>

    <!-- pay if user is loged -->
    <span v-if="loggedUser">
      {{loggedUser.firstName}} {{loggedUser.lastName}} <i>({{loggedUser.email}})</i>
      <!--    <v-btn depressed color="primary" type="button" @click="validateAndSubmit('dz')">
      <v-icon class="mr-2">mdi-arrow-right-circle</v-icon>&nbsp;&nbsp;{{$t('booking.process.paydz')}}
    </v-btn>    -->
      <br><br><br>
     <v-btn depressed color="primary" type="button" @click="validateAndSubmit('stripe')">
        <v-icon class="mr-2">mdi-arrow-right-circle</v-icon>&nbsp;&nbsp;{{$t('booking.process.payStripe')}}
      </v-btn>
    </span>

  </v-container>

</template>

<script>
  import { nationalities, countries } from '@/shared/data';
  import BookingHeader from './BookingHeader';
  import { BookingSteps } from "../models";
  import { Sexe } from '@/shared/models';
  import { BookingService } from "../services";
  import LoginForm from '../../../shared/components/LoginForm'
  import { mapGetters } from 'vuex'
  import { LocationsApi } from '../../../shared/services/api'

  export default {
    name: 'BookingUserInfoStep',
    props: {
      bookingContext: null
    },
    data () {
      return {
        loading: false,
        birthDateMenuOpen: false,
        activePicker: null,
        delivrationDateMenuOpen: false,
        nationalities,
        countries,
        Sexe,
        error: null
      };
    },
    watch: {
      birthDateMenuOpen (val) {
        val && setTimeout(() => this.activePicker = 'YEAR');
      }
    },
    methods: {
      validateAndSubmit (paymentType) {
        this.loading = true;
        this.error = null;
        this.bookingContext.paymentType = paymentType;

        console.log("BookingNumber", this.bookingContext.number);
        //If number exist, mean the location already saved.
        if (this.bookingContext.number) {
          this.$emit('nextStep', this.bookingContext);
        } else {
          LocationsApi.book(this.bookingContext, this.$store.getters['booking/avail'])
            .then(bookingNumber => {
              this.bookingContext.number = bookingNumber;
              this.$store.commit('booking/setContext', this.bookingContext);
              this.$emit('nextStep', this.bookingContext);
            })
            .catch(error => {
              this.error = error;
            })
            .finally(() => this.loading = false);
        }

      }
    },
    computed: {
      ...mapGetters({ loggedUser: 'main/loggedUser' }),
      filteredNationalities () {
        return this.nationalities
          .filter(option => option
            .toString()
            .toLowerCase()
            .indexOf(this.bookingContext.user.driverInformation.nationality.toLowerCase()) >= 0
          );
      },
      filteredCountries () {
        return this.countries
          .filter(option => option && option.name
            .toString()
            .toLowerCase()
            .indexOf(this.bookingContext.user.address.country.toLowerCase()) >= 0
          );
      }
    },
    components: { LoginForm, BookingHeader }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @media (min-width: 960px) {
    .container {
      width: 66rem;
    }

    .padding-like-field {
      padding: 5.12rem 0 0 0;
    }

    .box {
      margin: 1rem 2rem !important;
    }

    .padding-comment {
      padding: 1rem 10rem !important;
    }
  }

  .padding-top {
    padding-top: 4rem;
  }

  .padding-comment {
    padding: 0.8rem;
  }

  .box {
    margin: 0.3rem;
  }


</style>
